module.exports = __webpack_public_path__ + "static/media/logos--oracle.64028471.png";